export default {
 ADMIN: 'admin',
 UVREP: 'uv-rep'
};